// extracted by mini-css-extract-plugin
export default {"container":"yN-z","title":"zN-z","link":"AN-z"};